import { REDUX_STATUS } from '@gymaholic/packages'
import setUtil from 'utils/set'
import { getObjectUtil } from 'packages/src'

function loadSuccessReduxReducer (state, action) {
  const {
    path,
    domainListPath
  } = action.payload
  const domainListOrObjPath = domainListPath || path
  const domainListOrObj = getObjectUtil(state, domainListPath || path) || {}
  return setUtil(state, domainListOrObjPath, {
    ...domainListOrObj,
    status: REDUX_STATUS.SUCCESS
  })
}

export {
  loadSuccessReduxReducer
}
